import { HistoryEvent, listen } from 'weblite-router'
import { modalQueue } from '../queue'
import { addToRouter, getCurrentCid } from './router'
// import { windowOnLoad } from '../../hooks/windowOnLoad'
import { notifyClosedAllModals } from '../event-listener'

let lastCID = null

listen(event => {
  // if (event === 'INIT') windowOnLoad()
  if (event === HistoryEvent.POP && !getCurrentCid() && lastCID) {
    modalQueue.dequeue()
    const { id, preventBackClick, closeImmediately } = modalQueue.head() || {}

    // TODO[router]: Investigate why setTimeout is needed
    setTimeout(() => {
      if (id) addToRouter({ cid: id, preventBackClick, closeImmediately })
      else notifyClosedAllModals()
    }, 0)
  }

  lastCID = getCurrentCid()
})
